import React, { FC } from "react";

import QRCode from "react-qr-code";

import { AUTH_CONFIG } from "../constants/auth.constants";

interface QRLoginProps {
  value: string;
  isLoading?: boolean;
}

const QRLogin: FC<QRLoginProps> = ({ value, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[220px] w-[220px] bg-gray-50 border border-gray-200 rounded-lg">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center">
      <QRCode
        style={{
          height: AUTH_CONFIG.QR_SIZE,
          width: AUTH_CONFIG.QR_SIZE,
        }}
        value={value}
      />
    </div>
  );
};

export default QRLogin;
